export default "__VITE_ASSET__DgRI_WJd__"